export const isActiveBotStatus = (status: unknown): boolean => {
  const code = Number(status)
  return code === 1 || code === 2
}
